<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-recharge :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- <add-btn v-hasPermi="['cont:newIncome:add']" @add="handleAddPayment" /> -->
    <van-tabs v-model="active" @change="handleClick">
      <!-- <van-tab name="0" title="未申请" :badge="countItem.wzxCount != 0?countItem.wzxCount:''"></van-tab> -->

      <van-tab name="2" title="已申请" :badge="countItem.yzxCount != 0?countItem.yzxCount:''"></van-tab>
      <van-tab name="3" title="已充值" :badge="countItem.yczCount != 0?countItem.yczCount:''"></van-tab>
      <van-tab name="1" title="驳回" :badge="countItem.bszxCount != 0?countItem.bszxCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <div style="display: flex; align-items: center; height:100%; width:100%">
          <div style="flex: 1;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.contractName}}
              </div>
            </div>
            <div style="font-size: 12px;">合同编号：{{item.contractNum}}</div>
            <div style="font-size: 12px;">执行客户：{{item.execCustomerName || '--'}}</div>
            <div style="font-size: 12px">垫款金额：<span style="color: #ee0a24; ">{{item.payMoney}}(元)</span></div>
            <div style="font-size: 12px">现金金额：<span style="color: #1989fa; ">{{item.payRechargeMoney}}(元)</span></div>
            <div style="font-size: 12px">充值剩余金额：<span style="color: #1989fa; ">{{item.rechargeRemainMoney}}(元)</span></div>
            <div style="font-size: 12px;">账户ID：{{item.accountNo}}</div>
            <div style="font-size: 12px;">总账户币：{{item.rechargeMoney}}</div>
            <div style="font-size: 12px;">申请时间：{{item.applyTime}}</div>
            <div style="color: #666; font-size: 12px">
              申请信息：{{item.deptName}}<span style="color: #1989fa; margin: 0 5px;">{{item.userName}}</span>
            </div>
            <div style="color: #666; font-size: 12px" v-if="active != 0">
              媒介信息：{{item.mediaDeptName}}<span style="color: #1989fa; margin: 0 5px;">{{item.mediaUserName}}</span>
            </div>
            <!-- {{item.createTime}} -->
          </div>
          <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import advances from '@/api/channel/advances'
// import channel from '@/api/channel/channel'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchRecharge from '@/views/channel/recharge/Search.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Toast, Tab, Tabs, DatetimePicker } from 'vant'
// import AddBtn from '@/components/common/AddBtn'
// import { companyList } from '@/api/admi/dept'

export default {
  name: 'approve',
  components: {
    // AddBtn,
    SearchComponent,
    SearchRecharge,
    EmptyComponent,
    TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {},
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        // getStatus: 1,
        execType: 2,
        dataType: 3,
        scrollTop: null,
        orderByColumn: 'applyTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    // 存在 读缓存
    if (sessionStorage.getItem('rechargeSearch')) {
      this.queryParams = JSON.parse(sessionStorage.getItem('rechargeQuery'))
      this.queryParams.pageSize = this.queryParams.pageNum * 10
      this.queryParams.pageNum = 1
      document.documentElement.scrollTop = this.queryParams.scrollTop
      this.active = this.queryParams.execType
    } else {
      sessionStorage.removeItem('rechargeQuery')
    }
    if (this.$route.query.active) {
      this.active = this.$route.query.active
      this.queryParams.execType = this.$route.query.active
    }
    await this.handleList()
    await this.getCountItem()
    if (sessionStorage.getItem('rechargeSearch')) {
      document.documentElement.scrollTop = this.queryParams.scrollTop
    }
  },
  mounted() {
    this.init()
  },
  destroyed() {
    // 销毁组件
    sessionStorage.removeItem('rechargeSearch')
    // sessionStorage.removeItem('paymentQuery')
  },
  methods: {
    async init() {
      document.title = '充值列表'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.custName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      sessionStorage.removeItem('rechargeSearch')
      sessionStorage.removeItem('rechargeQuery')
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getCountItem()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      this.queryParams.scrollTop = scrollTop
      sessionStorage.setItem('rechargeQuery', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/cont/payment/rechargeDetail',
        query: { contractId: item.contractId, contNewIncomeDetailId: item.advancesRechargeId, dataType: 3, type: 'advances' }
      })
    },
    async handleList() {
      this.loading = true
      const res = await advances.listAdvancesRecharge(this.queryParams)
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        if (this.queryParams.pageSize > 10 && this.queryParams.pageNum == 1) {
          this.queryParams.pageNum = this.queryParams.pageSize / 10
          this.queryParams.pageSize = 10
        }
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    // 查询打款记录数量
    getCountItem() {
      // this.queryParams.execType = null
      advances.getAdvancesRechargeCountItem({ ...this.queryParams, execType: null }).then(res => {
        if (res.code === 200) {
          this.countItem = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
      this.getCountItem()
    },
    handleClick(tab, event) {
      this.queryParams.execType = tab
      this.queryCustList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.cust /deep/.van-dialog__content {
  padding: 0 20px;
}
</style>
